const defaultStudioSettings = {
	channel: "left",
	input: "default",
	output: "default",
	releaseChannel: "latest",
};

export default defaultStudioSettings;
